import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Actualizado:',
  breadcrumbs: {
    home: 'Inicio',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Por qué puedes confiar en nosotros',
        details: {
          text: '<h2>Por qué puedes confiar en nosotros</h2><p>Los artículos en Natu.Care se escriben basándose en investigación científica, datos de sitios web gubernamentales y otras fuentes fiables. Los textos se redactan en cooperación con médicos, nutricionistas y otros expertos en salud y belleza. Los artículos se revisan antes de su publicación y durante las actualizaciones significativas.</p>.',
          footerText: '<p>Más información sobre nuestro <a href="/es/acerca-de/proceso-editorial">proceso editorial</a></p>.'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Información sobre anuncios',
        details: {
          text: '<h2>Información sobre anuncios</h2><p>El contenido de Natu.Care puede contener enlaces a productos de cuya venta podemos recibir una comisión. Al crear contenido, nos adherimos a altos estándares editoriales y nos preocupamos por ser objetivos sobre los productos discutidos. La presencia de enlaces de afiliados no está dictada por nuestros socios, y seleccionamos los productos que revisamos de forma completamente independiente.</p>.',
          footerText: '<p>Más información sobre nuestros <a href="/es/terminos-de-servicio">términos y condiciones</a></p>.',
        }
      }
    ],
    tooltip: {
      labelVerified: 'Verificado por un experto',
      footerText: '<p>Más información sobre nuestro <a href="/es/acerca-de/proceso-editorial">proceso editorial</a></p>.'
    }
  },

  mediabar: {
    heading: 'Medios sobre nosotros:',
    href: '/es/acerca-de',
    title: 'Medios sobre nosotros:',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Cuida un cuerpo sano',
    description: `Prueba los suplementos de alta calidad de Natu.Care`,
    button: {label: 'Ver productos', href: 'https://natu.shop/collections'},
    picture: {alt: 'Mujeres jóvenes y hermosas con buena condición de la piel'}
  },

  authorship: {
    heading: 'Editoriales',
    link: {
      label: 'Conoce al equipo',
      href: '/es/acerca-de/equipo-editorial'
    }
  },

  similarArticles: {
    headingBlogList: 'Artículos',
    headingBlogPost: 'Artículos similares'
  }  
};